import * as Sentry from "@sentry/react-native";
import Constants from "expo-constants";
import { Platform } from "react-native";
import { environment } from "~/environment";

let isSentryInitialized = false;

export async function initializeSentry() {
  if (__DEV__) return;

  if (!environment.SENTRY_DSN) {
    console.log(
      "[Warning in initializeSentry] SENTRY_DSN is not set in .env.local file",
    );
    return;
  }

  try {
    if (!isSentryInitialized) {
      Sentry.init({
        release: `${Constants.expoConfig?.version}-${Platform.OS}`,
        dsn: environment.SENTRY_DSN,
        debug: false,
        environment: environment.ENVIRONMENT_NAME,
        sendDefaultPii: false,
        autoSessionTracking: true,
        enableNative: true,
        autoInitializeNativeSdk: true,
        enableNativeCrashHandling: true,
        enableAutoSessionTracking: true,
        enableAutoPerformanceTracing: false,
        ignoreErrors: [/Network Error/i],
        maxValueLength: 1000,
      });

      isSentryInitialized = true;
    }
  } catch (error) {
    console.log("[Error in initializeSentry]", String(error));
  }
}
